import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export type UserAccountStatus = 'active' | 'inactive' | 'blocked' | 'cancelled';

export interface UserLookupResult {
  found: boolean;
  user?: {
    id: number;
    name: string;
    email: string;
    document_number: string;
    status_id: number;
    status: UserAccountStatus;
  };
  already_in_company?: {
    role_id: number;
    role_name: string;
  };
}

export type ExistingUserRoleKind = 'operator' | 'coordinator' | 'manager' | 'administrator';

/**
 * Consulta se um email já tem cadastro na plataforma. `company_id` é
 * obrigatório e define o escopo — a resposta só menciona vínculo com
 * ESSA empresa (isolamento multi-tenant). Ver
 * chave-cmb-api/src/modules/users/useCases/lookup-by-email/*.
 */
export async function lookupUserByEmail(email: string, company_id: number): Promise<UserLookupResult> {
  const { data } = await axios.get<{ data: UserLookupResult }>(
    `${API_URL}/users/lookup-by-email`,
    { params: { email, company_id } },
  );
  return data.data;
}

/**
 * Vincula um user existente a uma empresa como o role especificado.
 * Bate no endpoint /{role}s/add-companies que já aceita o array
 * [{user_id, company_id}, ...].
 */
export async function linkExistingUserToCompany(
  role: ExistingUserRoleKind,
  user_id: number,
  company_id: number,
): Promise<void> {
  // Path plural. `administrator` vira `administrators`, resto igual.
  const path = role === 'administrator' ? 'administrators'
    : role === 'coordinator' ? 'coordinators'
    : role === 'manager' ? 'managers'
    : 'operators';
  await axios.post(`${API_URL}/${path}/add-companies`, [{ user_id, company_id }]);
}
